/* eslint-disable camelcase */
export enum ProportionalSaleTypes {
  GET_PROPORTIONAL_SALE_REQUEST = '@proportional_sale/GET_PROPORTIONAL_SALE_REQUEST',
  GET_PROPORTIONAL_SALE_SUCCESS = '@proportional_sale/GET_PROPORTIONAL_SALE_SUCCESS',
  GET_PROPORTIONAL_SALE_FAILURE = '@proportional_sale/GET_PROPORTIONAL_SALE_FAILURE',
  GET_SIMULATE_REGISTER_REQUEST = '@proportional_sale/GET_SIMULATE_REGISTER_REQUEST',
  GET_SIMULATE_REGISTER_SUCCESS = '@proportional_sale/GET_SIMULATE_REGISTER_SUCCESS',
  GET_SIMULATE_REGISTER_FAILURE = '@proportional_sale/GET_SIMULATE_REGISTER_FAILURE',
  GET_SIMULATE_WAS_SUBSCRIBER_REQUEST = '@proportional_sale/GET_SIMULATE_WAS_SUBSCRIBER_REQUEST',
  GET_SIMULATE_WAS_SUBSCRIBER_SUCCESS = '@proportional_sale/GET_SIMULATE_WAS_SUBSCRIBER_SUCCESS',
  GET_SIMULATE_WAS_SUBSCRIBER_FAILURE = '@proportional_sale/GET_SIMULATE_WAS_SUBSCRIBER_FAILURE',
  CAMPAIGN_SIMULATION_REQUEST = '@proportional_sale/CAMPAIGN_SIMULATION_REQUEST',
  CAMPAIGN_SIMULATION_SUCCESS = '@proportional_sale/CAMPAIGN_SIMULATION_SUCCESS',
  CAMPAIGN_SIMULATION_FAILURE = '@proportional_sale/CAMPAIGN_SIMULATION_FAILURE',

  DADOS_PROPORTIONAL_SALE = '@proportional_sale/DADOS_PROPORTIONAL_SALE',
  PAYMENT = '@proportional_sale/PAYMENT',
}

export interface ServiceTypes {
  id: number;
  nome: string;
  descricao: string;
  plano: string;
  quantidade: number;
  status_id: number;
  valor: number;
  valor_adicional: string;
  valor_servico: string;
  valor_unitario: string;
}

export interface ProportionalDadosTypes {
  total_maximo_parcelas: number;
  valor_base: number;
  valor_adicional: number;
  servicos: Array<ServiceTypes>;
  valor_negociacao: number;
  valor_variacao_forma_pagamento: number;
  valor_final: number;
  valor_parcela: string;
  payment_form: number;
  vigencia_inicio: string;
  vigencia_fim: string;
  parcelamento: object;
  plano_id: number;
  servico: Array<number>;
  parcelas_cartao: Array<number>;
  parcelas_boleto: Array<number>;
}

export interface ServiceDetailedTypes {
  id: number;
  nome: string;
  plano: string;
  quantidade: number;
  status_id: number;
  valor: number;
  valor_adicional: number;
  valor_servico: number;
  valor_unitario: string;
}

export interface SimulateRegisterTypes {
  plano_id: number;
  vigencia_inicio: string;
  vigencia_fim: string;
  parcelas_boleto: object;
  parcelas_cartao: object;
  servicos: Array<ServiceDetailedTypes>;
  total_maximo_parcelas: number;
  valor_adicional: number;
  valor_base: number;
  valor_final: number;
  valor_negociacao: number;
  valor_parcela: number;
  valor_parcela_cartao: number;
  valor_total_cartao: number;
  valor_variacao_forma_pagamento: number;
  payment: string;
}

export interface RequestState {
  sale: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  sale_register: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  campaign_simulation: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface ProportionalSaleState {
  proportional_sale: ProportionalDadosTypes;
  campaign_simulation: ProportionalDadosTypes;
  readonly simulate_register: SimulateRegisterTypes;
  readonly request: RequestState;
}
